module.exports = __webpack_public_path__ + "static/media/test2.315e3e9a.png";